import React from 'react'
import Header from './Components/Header';
import ListingRentComp from './Components/ListingRentComp';
import Footer from './Components/Footer';


function ListingRent() {

    return (
        <div>
            <Header />
            <ListingRentComp />
            <Footer />
        </div>
    )
}

export default ListingRent